import { getBackendUrl } from "@Utils";
import {
  BarSeries,
  Category,
  ChartComponent,
  DataLabel,
  Highlight,
  Inject,
  Legend,
  SeriesCollectionDirective,
  SeriesDirective,
  Tooltip,
} from "@syncfusion/ej2-react-charts";
import { useContext, useEffect, useState } from "react";
import axiosWrapper from "../../services/axiosWrapper";
import NoPortalDataIllustration from "./NoPortalData";
import { ThemeContext } from "../../ProviderApp";
import { THEME_LIGHT } from "../../App.constant";
import FutureModuleIllustrationOfEstimates from "../../assets/images/FutureModuleIllustrationOfEstimates.svg";
import css from "./index.module.css";
import { useTranslation } from "react-i18next";

function EstimateGraphTile({ filterData }) {
  const [barData, setBarData] = useState([]);
  const [totalBarData, setTotalBarData] = useState([]);
  const themeContext = useContext(ThemeContext);
  const { t } = useTranslation();
  useEffect(() => {
    axiosWrapper
      .post(`${getBackendUrl()}/dsr/portalGraph`)
      .then((response) => {
        const b = response.data;
        setTotalBarData(b);
      })
      .catch();
  }, []);

  useEffect(() => {
    setBarData(
      totalBarData.slice(
        filterData.EstimateGraphTile.skip,
        filterData.EstimateGraphTile.skip + filterData.EstimateGraphTile.take,
      ),
    );
  }, [filterData.EstimateGraphTile, totalBarData]);

  const pointRender = (args) => {
    const seriesColor = ["#1080D6", "#38BA84", "#FECD04", "#5BB8FF", "#FF6D6F", "#FF5B1B", "#5B5496", "#DD8F49"];
    args.fill = seriesColor[args.point.index];
  };

  return ["prodff"].includes(process.env.REACT_APP_ENV) ? (
    <div className={css.estimatesBlockedClass}>
      <img className={css.estimateImage} src={FutureModuleIllustrationOfEstimates} />
      <div>
        <span>This module is only available on the Enterprise plan. For further details</span>{" "}
        <span className={css.contactSupportBorder}>
          <a href="https://support.cube.ms/portal/2" target="_blank" className={css.contactSupport} rel="noreferrer">
            Contact Support
          </a>
        </span>
      </div>
    </div>
  ) : barData.length > 0 ? (
    <ChartComponent
      style={{ textAlign: "center" }}
      primaryXAxis={{
        majorGridLines: { width: 0 },
        majorTickLines: { width: 0 },
        labelFormat: "{name}",
        valueType: "Category",
        labelStyle: {
          color: themeContext.themeType == THEME_LIGHT ? "var(--primary-text)" : "var(--surface-white)",
        },
      }}
      primaryYAxis={{
        majorGridLines: { width: 0 },
        majorTickLines: { width: 0 },
        edgeLabelPlacement: "Shift",
        labelStyle: {
          color: themeContext.themeType == THEME_LIGHT ? "var(--primary-text)" : "var(--surface-white)",
        },
      }}
      chartArea={{ border: { width: 0 } }}
      width="100%"
      tooltip={{ enable: true }}
      pointRender={pointRender}
    >
      <Inject services={[BarSeries, DataLabel, Category, Legend, Tooltip, Highlight]} />
      <SeriesCollectionDirective>
        <SeriesDirective dataSource={barData} xName="x" yName="y" type="Bar" />
      </SeriesCollectionDirective>
    </ChartComponent>
  ) : (
    <NoPortalDataIllustration name={t("Estimates")} />
  );
}

export default EstimateGraphTile;
